module.exports = __webpack_public_path__ + "img/LA PAZ.26ca53fd.png";